<template>
	<div>
		<div>推广时间：{{ row?.promotionStartTime }} 至 {{ row?.promotionEndTime }}</div>
		<div>活动名称：{{ row?.activityName || '-' }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped></style>
